import React from "react"
import { useStaticQuery, graphql } from "gatsby"

const ListItem = ({ data }) => {
    return (
        <li className="inline-block social-link mx-3 lg:mx-6">
            <a href={data.url} title={data.name} className="rounded-full inline-block transition-shadow duration-300 hover:shadow-2xl">
                <img src={data.icon} alt={data.name} className="block w-16"/>
            </a>
        </li>
    )
}

export default () => {
    const data = useStaticQuery(graphql`
        query SocialQuery {
            site {
                siteMetadata {
                    social {
                        name
                        url
                        icon
                    }
                }
            }
        }
    `)

    const items = data.site.siteMetadata.social
    let list = items.map((e, i) => (
        <ListItem key={e.url + "-" + e.icon + "-" + i} data={e} />
    ))

    // 最終的にレンダリングされるのはここ
    return (
        <div className="text-center">
            <ul className="mt-3 pt-3">{list}</ul>
        </div>
    )
}
